import type { CoreProviderConfig } from '@openx/components-core/utils/context/CoreContext';
import { requireDefaults } from '@openx/components-core/utils/context/requiredDefaults';
import { useHistoryFetch } from './utils/useHistoryFetch';

export const coreConfig: CoreProviderConfig = {
  ...requireDefaults,
  useHistoryFetch,
};
